import integrationActionTypes from '../../integration/constants/action-types';
import setLocale from '../actions/set-locale';

const localeSetter = (store) => (next) => (action) => {
  if (action.type === integrationActionTypes.SET_INTEGRATION_SETTINGS) {
    const { locale } = action.payload.settings;
    store.dispatch(setLocale(locale));
  }
  next(action);
};
export default localeSetter;
